export default (
  resetHistory,
  fullName,
  tagline,
  phoneNumber,
  email,
  address,
  objective,
  personalLinks,
  documentPicture,
) => {
  resetHistory({
    history: {
      tail: {
        data: {
          activeElementData: {
            personalInfo: {
              fullName,
              tagline,
              phoneNumber,
              email,
              address,
              objective,
              personalLinks,
              documentPicture,
            },
          },
          sectionKey: 'personalInfo',
          documentPicture,
        },
        next: null,
        prev: null,
        index: 0,
        changeData: [],
      },
    },
  });
};
